/**
 * Conversation Origin Types - Rails STI types for conversation origins
 *
 * These correspond to the `origin_type` column in interact_conversations table.
 * Used across frontend components to identify what started a conversation.
 */

export const CONVERSATION_ORIGIN_TYPES = {
  PITCH: 'Interact::Pitch',
  // Peer DMs (PR↔PR or Media↔Media direct messages) — `origin_type` is the participant's
  // Profile STI. The backend locks these conversations to strict 1:1, so features that fan
  // out (e.g., add-participant) must be disabled on these threads.
  PROMOTER: 'Id::Profile::Promoter',
  MEDIA_PROFILE: 'Id::Profile::MediaProfile',
};

/**
 * Check if a conversation originated from a pitch
 * @param {string} originType - The origin_type string to check
 * @returns {boolean}
 */
export const isPitchOrigin = (originType) => originType === CONVERSATION_ORIGIN_TYPES.PITCH;

/**
 * Check if a conversation is a peer DM (PR↔PR or Media↔Media direct message).
 * Peer DMs are locked to strict 1:1 by the backend — features that fan out (e.g., add
 * participants) should be disabled on these threads.
 * @param {string} originType - The origin_type string to check
 * @returns {boolean}
 */
export const isPeerDmOrigin = (originType) => (
  originType === CONVERSATION_ORIGIN_TYPES.PROMOTER || originType === CONVERSATION_ORIGIN_TYPES.MEDIA_PROFILE
);
